import { Component, Input } from '@angular/core';
import { SortOptions } from '@fgb/portal-component-library/src/lib/directives';
import { fgbAnimations } from '@fgb/portal-component-library/src/lib/shared/animations';
import { FilterFn } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { DateTime } from 'luxon';

@Component({
  selector: 'fgbcl-games-with-tickets-list',
  templateUrl: './games-with-tickets-list.component.html',
  styleUrl: './games-with-tickets-list.component.scss',
  animations: [
    fgbAnimations
  ]
})
export class GamesWithTicketsListComponent {
  // Filters and sort non-past tickets
  @Input() ticketsFilters: FilterFn[] = [
    (game: any) => DateTime.fromISO(game.Date, { zone: 'utc' }).endOf('day') > DateTime.utc()
  ];
  @Input() ticketsSortOptions: SortOptions<any> = {
    date: (a: any, b: any) => DateTime.fromISO(a.Date, { zone: 'utc' }).diff(DateTime.fromISO(b.Date, { zone: 'utc' })).milliseconds
  };
  // Filters and sort past tickets
  @Input() pastTicketsFilters: FilterFn[] = [
    (game: any) => DateTime.fromISO(game.Date, { zone: 'utc' }).endOf('day') < DateTime.utc()
  ];
  @Input() pastTicketsSortOptions: SortOptions<any> = {
    date: (a: any, b: any) => DateTime.fromISO(b.Date, { zone: 'utc' }).diff(DateTime.fromISO(a.Date, { zone: 'utc' })).milliseconds
  };
  isPastGamesOpen: boolean = false;

  toggle(): void{
    this.isPastGamesOpen = !this.isPastGamesOpen;
  }

}
